// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__32_lq","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1kNVo"};